import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-direct-app-invitation',
  templateUrl: './direct-app-invitation.component.html',
  styleUrls: ['./direct-app-invitation.component.css']
})
export class DirectAppInvitationComponent implements OnInit {
  step1 = 0;

  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  constructor() { }

  @ViewChild('stepper1', null) stepper: MatStepper;
  ngOnInit() {
  }

 ngAfterViewInit() {
    this.stepperChange(0);
  }
  stepperChange(index: number) {
    const data = document.getElementsByClassName('stpMenu');
    if (data) {
      data[index].classList.add('sm-a');
      for (let i = 0; i < data.length; i++) {
        if (index === i) {
        } else { data[i].classList.remove('sm-a'); }
      }
    }
  }
  createView(n) {
    this.step1 = n.selectedIndex;
    this.stepperChange(n.selectedIndex);
  }
  selectionChange(n) {
    if (n === 'next') {
      this.stepper.next();
    } else if (n === 'previous') {
      this.stepper.previous();
    }
  }

}
